<template>
  <div>
    <template v-if="isEnable">
      <input ref="nativeInput" @blur="handleBlur" v-model="localAmount" @change="onChangeHandler" @keyup.enter="keyupProcess" type="number" class="peiso-input-number" :disabled="disabled">
    </template>
    <template v-else>
      <vue-numeric
        class="peiso-input-number"
        :empty-value="emptyValue"
        :minus="minus"
        :precision="precision "
        :currency="currency"
        separator=","
        :disabled="disabled"
        v-model="localAmount"
        @focus="handleFocus"
        @change="onChangeHandler"
        @keyup.native.enter="keyupProcess"
      >
      </vue-numeric>
    </template>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'

export default {
  props: {
    emptyValue: {
      default: 0,
    },
    minus: {
      default: true
    },
    precision: {
      default: null
    },
    disabled: {
      default: false
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    currency: {
      default: '$'
    }
  },
  components: {
    VueNumeric
  },
  data() {
    return {
      isEnable: false,
      localAmount: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.localAmount = newValue;
    },
    localAmount(newValue) {
      this.$emit('input', newValue);
    }
  },
  methods: {
    onChangeHandler (e) { 
      this.$emit('change', e)
    },
    handleFocus() {
      if (!this.localAmount) {
        this.localAmount = '';
        this.isEnable = true;
        this.$nextTick(() => {
          this.$refs.nativeInput.focus();
        });
      } else {
        this.isEnable = false;
      }
    },
    handleBlur() {
      if (!this.localAmount) {
        this.localAmount = 0;
      }
      this.isEnable = false;
    },
    keyupProcess() {
      this.$emit('nextInput')
    }
  },
  mounted() {
    this.localAmount = this.value;

    // In case of delayed props value.
    setTimeout(() => {
      this.localAmount = this.value;
    }, 500);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/input/inputNumber.vue